import React from "react";
import { useVersionCheck } from "../hooks/useVersionCheck";

async function clearCachesAndReload() {
  if ("caches" in window) {
    const keys = await caches.keys();
    await Promise.all(keys.map((key) => caches.delete(key)));
  }
  if ("serviceWorker" in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((r) => r.unregister()));
  }
  window.location.reload();
}

export function VersionUpdateBanner() {
  const updateAvailable = useVersionCheck();

  if (!updateAvailable) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 99999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 16,
        padding: "10px 16px",
        backgroundColor: "#1a73e8",
        color: "#fff",
        fontSize: "0.9rem",
        fontFamily: "inherit",
        boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
      }}
    >
      <span>A new version of this app is available.</span>
      <button
        name="reload-app"
        aria-label="Reload app"
        data-action="reload-app"
        onClick={clearCachesAndReload}
        style={{
          padding: "4px 16px",
          borderRadius: 4,
          border: "none",
          backgroundColor: "#fff",
          color: "#1a73e8",
          fontWeight: 600,
          cursor: "pointer",
          fontSize: "0.85rem",
        }}
      >
        Reload
      </button>
    </div>
  );
}
